<div class="dashboard-page container-page">
    <div class="title-page d-flex justify-content-between">
        <div class="title">
            Danh sách sản phẩm
        </div>
        <BreadcrumbComponent></BreadcrumbComponent>
    </div>
    <div style="background: #f7f8f9;height: 100%">
        <div class="container-fluid">
            <div class="card">
                <div class="card-body">
                    <div class="alert alert-danger alert-dismissible fade show" role="alert" v-if="messError">
                        <span>{{messError}}</span>
                        <button type="button" class="close" data-dismiss="alert" aria-label="Close" @click="removeError">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="search-component d-flex flex-wrap">
                        <div class="col-sm-12 d-flex justify-content-between flex-wrap">
                            <div class="col-sm-11 d-flex flex-column">
                                <div class="col-sm-12 d-flex gap-5 flex-wrap">
                                    <div class="col-sm-3">
                                        <InputTextNormal
                                                :label="dataSearch.store_name.label"
                                                :id="dataSearch.store_name.id"
                                                :placeholder="dataSearch.store_name.placeholder"
                                                :value-default="dataSearch.store_name.value"
                                                @inputValue="onChange($event, dataSearch.store_name.id)"
                                                :required="dataSearch.store_name.required"
                                        ></InputTextNormal>
                                    </div>
                                    <div class="col-sm-3">
                                        <InputTextNormal
                                                :label="dataSearch.store_code.label"
                                                :id="dataSearch.store_code.id"
                                                :placeholder="dataSearch.store_code.placeholder"
                                                :value-default="dataSearch.store_code.value"
                                                @inputValue="onChange($event, dataSearch.store_code.id)"
                                                :required="dataSearch.store_code.required"
                                        ></InputTextNormal>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-1 d-flex flex-column justify-content-end">
                                <ButtonSearchComponent :label="labelButtonSearch" @click="searchProducts"></ButtonSearchComponent>
                            </div>
                        </div>

                    </div>
                    <div class="btn-invite-partner">
                        <ButtonAddComponent :width="'200px'" :label="labelButtonCreate" @click="redirectToCreate" ></ButtonAddComponent>
                    </div>
                    <div class="col-sm-12 d-flex justify-content-between mt-4">
                        <div class="action d-flex align-items-center gap-3">
                            <div class="total">
                                {{ CommonText.TOTAL_RECORD(listStores.length, paginate.itemCount) }}
                            </div>
                            <div class="dropdown-action">
                                <SelectCustom
                                    :label="selectAction.label"
                                    :id="selectAction.id"
                                    :placeholder="selectAction.placeholder"
                                    :value-default="selectAction.value"
                                    :required="selectAction.required"
                                    :options="selectAction.options"
                                    @action="actionSelect($event)"
                                ></SelectCustom>
                            </div>
                        </div>
                        <div class="action-left d-flex align-items-center gap-3">
                            <div class="dropdown-action">
                                <SelectCustom
                                        :label="selectLimitPage.label"
                                        :id="selectLimitPage.id"
                                        :placeholder="selectLimitPage.placeholder"
                                        :value-default="selectLimitPage.value"
                                        :required="selectLimitPage.required"
                                        :options="selectLimitPage.options"
                                        @action="actionLimitPage($event)"
                                ></SelectCustom>
                            </div>
                        </div>
                    </div>
                    <div class="list-partners-component">
                        <table class="table">
                            <thead>
                                <tr>
                                    <th scope="col" style="width: 2%;"><InputCheckboxOne id="select_all" :value-default="checkAll" @inputValue="onChangeSelectAll($event)" :checked="checkAll"></InputCheckboxOne></th>
                                    <th scope="col" v-for="header in dataHeaderTable" :key="header.order" :style="{ 'width': header.width }">{{header.label}}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-if="listStores.length > 0" v-for="store in listStores" :key="store.id">
                                    <td><InputCheckboxOne :id="store.id" :value-default="checkItems[store.id]" @inputValue="onChangeSelectItem($event, store.id)" :checked="checkItems[store.id]"></InputCheckboxOne></td>
                                    <td class="store-name"><p @click="showStoreDetail(store.id)">{{store.name}}</p></td>
                                    <td>{{store.code}}</td>
                                    <td>{{store.phone}}</td>
                                    <td>{{store.address}}</td>
                                </tr>
                                <tr v-else>
                                    <td colspan="10" class="text-center">Không có dữ lệu được tìm thấy!</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <PaginateComponent v-if="listStores.length > 0 && paginate.pageCount > 1" :paginate="paginate" :urlOrigin="urlOrigin" @page="emitPage($event)"></PaginateComponent>
                </div>
            </div>
        </div>
    </div>
</div>
<LoadingComponent v-if="isLoading"></LoadingComponent>

